import React from 'react';
import PropTypes from 'prop-types';

import {
  FacebookShareIcon,
  TwitterShareIcon,
  LinkedInShareIcon,
  WhatsappShareIcon,
} from 'components/icons';

import { socialShareLinks } from './scss/Update.module.scss';
import { getShareUrl } from './Update.helpers';

const UpdateShareButtons = ({ postTitle }) => {
  const shareLinks = [
    { platform: 'facebook', icon: FacebookShareIcon },
    { platform: 'twitter', icon: TwitterShareIcon },
    { platform: 'linkedin', icon: LinkedInShareIcon },
    { platform: 'whatsapp', icon: WhatsappShareIcon },
  ];
  return (
    <div className={socialShareLinks}>
      {shareLinks.map(({ platform, icon: Icon }, index) => (
        <a
          href={getShareUrl(postTitle, platform)}
          target="_blank"
          rel="noopener noreferrer"
          key={`share-link-${index}`}
        >
          <Icon className={platform} />
        </a>
      ))}
    </div>
  );
};

UpdateShareButtons.propTypes = {
  postTitle: PropTypes.string.isRequired,
};

export default UpdateShareButtons;
